import { convertDubaiToUTC } from "./convertDubaiToUTC";

export function formatLongDate(item, isNumber = false) {
    console.log('sss Hourse' , item)

    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

    const isValidYYYYMMDD =
        /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(item);
    const incomingDate = isValidYYYYMMDD ? new Date(item):  new Date (convertDubaiToUTC(item));
    // console.log('get Hourse' , incomingDate)
    const isMidnight = isValidYYYYMMDD ? isValidYYYYMMDD : incomingDate?.getHours() === 0 && incomingDate?.getMinutes() === 0;

    if (isNumber) {
        // Manual numeric formatting
        const dd = incomingDate.getDate().toString().padStart(2, "0");
        const mm = (incomingDate.getMonth() + 1).toString().padStart(2, "0");
        const yyyy = incomingDate.getFullYear();

        let timeStr = "";
        if (!isMidnight) {
            let hours = incomingDate.getHours();
            const minutes = incomingDate.getMinutes().toString().padStart(2, "0");
            const isEnglish = (localStorage.getItem('eahsLang') ?? 'en') == 'en';
            const ampm = hours >= 12 ? (isEnglish ? "PM" : 'م') : (isEnglish ? "AM" : 'ص');


            hours = hours % 12;
            hours = hours ? hours : 12; // 12 instead of 0
            hours = hours.toString().padStart(2, "0");

            timeStr = ` ${hours}:${minutes} ${ampm}`;
        }

        return `${dd}/${mm}/${yyyy}${timeStr}`;
    }

    // Normal long format
    const dateOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(!isMidnight && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }),
    };

    return incomingDate.toLocaleString(`${currentLanguage}-EG-u-nu-latn`, dateOptions);
}
